




import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class AdminEditIframe extends Vue {
  private remoteSrc = '';
  

  private setRemoteSrc() {
    const query = this.$route.query;
    const adminNo = this.$route.query.adminNo;
    const queryString = new URLSearchParams({ ...query, serviceType: 'PRO' }).toString();
    this.remoteSrc =
      process.env.VUE_APP_ADMIN_REMOTE_URL + `/configuration/management/edit/${adminNo}?${queryString}`;
  }

  created() {
    this.setRemoteSrc();
  }
}
